(function () {
  'use strict';

  const API = 'https://caviar-bar-chat.caviar-bar.workers.dev';
  const SESSION_KEY = 'cb_chat_session_id';
  const NAVY  = '#081b2d';
  const GOLD  = '#b89442';
  const GREEN = '#003f35';
  const BG    = '#f8f8f3';

  const CSS = `
    #cb-chat-bubble {
      position: fixed; bottom: 28px; right: 28px; z-index: 9999;
      width: 56px; height: 56px; border-radius: 50%;
      background: ${NAVY}; border: 2px solid ${GOLD};
      cursor: pointer; display: flex; align-items: center; justify-content: center;
      box-shadow: 0 4px 24px rgba(0,0,0,0.22);
      transition: transform 0.18s ease, box-shadow 0.18s ease;
    }
    #cb-chat-bubble:hover { transform: scale(1.07); box-shadow: 0 6px 32px rgba(0,0,0,0.30); }
    #cb-chat-bubble svg { display: block; }

    #cb-chat-panel {
      position: fixed; bottom: 96px; right: 28px; z-index: 9999;
      width: 360px; max-width: calc(100vw - 40px);
      background: #fff; border: 1px solid #e8e2d9;
      box-shadow: 0 8px 48px rgba(0,0,0,0.16);
      display: none; flex-direction: column;
      font-family: 'Helvetica Neue', Arial, sans-serif;
      overflow: hidden;
    }
    #cb-chat-panel.cb-open { display: flex; }

    #cb-chat-header {
      background: ${NAVY}; padding: 16px 20px;
      display: flex; align-items: center; justify-content: space-between;
    }
    #cb-chat-header-title {
      display: flex; align-items: center; gap: 10px;
    }
    #cb-chat-header-title img {
      width: 28px; height: auto; display: block;
    }
    #cb-chat-header-text { line-height: 1.3; }
    #cb-chat-header-text strong {
      display: block; color: #fff;
      font-family: Georgia, serif; font-size: 14px; font-weight: 400; letter-spacing: 0.5px;
    }
    #cb-chat-header-text span {
      font-size: 11px; color: ${GOLD}; letter-spacing: 1.5px; text-transform: uppercase;
    }
    #cb-chat-close {
      background: none; border: none; cursor: pointer;
      color: rgba(255,255,255,0.5); font-size: 20px; line-height: 1; padding: 0;
      transition: color 0.15s;
    }
    #cb-chat-close:hover { color: #fff; }

    #cb-chat-gold-line {
      height: 2px; background: ${GOLD}; flex-shrink: 0;
    }

    #cb-chat-messages {
      flex: 1; overflow-y: auto; padding: 20px 16px;
      min-height: 280px; max-height: 380px;
      background: ${BG}; display: flex; flex-direction: column; gap: 12px;
    }
    #cb-chat-messages::-webkit-scrollbar { width: 4px; }
    #cb-chat-messages::-webkit-scrollbar-track { background: transparent; }
    #cb-chat-messages::-webkit-scrollbar-thumb { background: #d4cfc6; border-radius: 2px; }

    .cb-msg {
      max-width: 88%; line-height: 1.6; font-size: 13.5px;
      padding: 10px 14px; border-radius: 2px;
      animation: cb-fadein 0.2s ease;
    }
    .cb-msg-assistant {
      background: #fff; color: ${NAVY}; border: 1px solid #e8e2d9;
      align-self: flex-start;
    }
    .cb-msg-user {
      background: ${NAVY}; color: #fff;
      align-self: flex-end;
    }
    .cb-msg-typing {
      background: #fff; border: 1px solid #e8e2d9;
      align-self: flex-start; padding: 12px 16px;
    }
    .cb-dots { display: flex; gap: 4px; align-items: center; }
    .cb-dots span {
      width: 5px; height: 5px; border-radius: 50%; background: ${GOLD};
      animation: cb-bounce 1.2s infinite ease-in-out;
    }
    .cb-dots span:nth-child(2) { animation-delay: 0.2s; }
    .cb-dots span:nth-child(3) { animation-delay: 0.4s; }

    #cb-chat-footer {
      border-top: 1px solid #e8e2d9; background: #fff;
      padding: 12px 14px; display: flex; align-items: flex-end; gap: 10px;
    }
    #cb-chat-input {
      flex: 1; border: 1px solid #d4cfc6; outline: none;
      padding: 9px 12px; font-size: 13px; color: ${NAVY};
      font-family: 'Helvetica Neue', Arial, sans-serif;
      resize: none; min-height: 38px; max-height: 100px;
      line-height: 1.5; border-radius: 2px;
      transition: border-color 0.15s;
    }
    #cb-chat-input:focus { border-color: ${GOLD}; }
    #cb-chat-input::placeholder { color: #aaa; }
    #cb-chat-send {
      background: ${GREEN}; border: none; cursor: pointer;
      color: #fff; padding: 9px 14px; font-size: 11px;
      font-weight: 700; letter-spacing: 1.5px; text-transform: uppercase;
      border-radius: 2px; white-space: nowrap; align-self: flex-end;
      transition: background 0.15s; height: 38px;
    }
    #cb-chat-send:hover { background: #004d42; }
    #cb-chat-send:disabled { opacity: 0.5; cursor: default; }

    #cb-chat-byline {
      text-align: center; font-size: 10px; color: #aaa;
      letter-spacing: 0.5px; padding: 6px 0 10px;
      background: #fff;
    }

    @keyframes cb-fadein {
      from { opacity: 0; transform: translateY(4px); }
      to   { opacity: 1; transform: translateY(0); }
    }
    @keyframes cb-bounce {
      0%, 80%, 100% { transform: scale(0.7); opacity: 0.5; }
      40%           { transform: scale(1.0); opacity: 1; }
    }

    @media (max-width: 400px) {
      #cb-chat-panel { right: 0; bottom: 80px; width: 100vw; border-left: none; border-right: none; }
      #cb-chat-bubble { right: 16px; bottom: 16px; }
    }
  `;

  function injectStyles() {
    const el = document.createElement('style');
    el.textContent = CSS;
    document.head.appendChild(el);
  }

  function getSessionId() {
    try {
      let id = window.localStorage.getItem(SESSION_KEY);
      if (!id) {
        id = window.crypto && window.crypto.randomUUID
          ? window.crypto.randomUUID()
          : `${Date.now()}-${Math.random().toString(16).slice(2)}`;
        window.localStorage.setItem(SESSION_KEY, id);
      }
      return id;
    } catch {
      return `${Date.now()}-${Math.random().toString(16).slice(2)}`;
    }
  }

  function buildPanel() {
    const panel = document.createElement('div');
    panel.id = 'cb-chat-panel';
    panel.setAttribute('role', 'dialog');
    panel.setAttribute('aria-label', 'The Caviar Bar concierge');
    panel.innerHTML = `
      <div id="cb-chat-header">
        <div id="cb-chat-header-title">
          <img src="${window.CB_LOGO_URL || '//vin0tq-5h.myshopify.com/cdn/shop/t/2/assets/logo.png'}" alt="The Caviar Bar">
          <div id="cb-chat-header-text">
            <strong>The Caviar Bar</strong>
            <span>Concierge</span>
          </div>
        </div>
        <button id="cb-chat-close" aria-label="Close chat">&#x2715;</button>
      </div>
      <div id="cb-chat-gold-line"></div>
      <div id="cb-chat-messages" role="log" aria-live="polite"></div>
      <div id="cb-chat-footer">
        <textarea id="cb-chat-input" placeholder="Ask about our range, delivery or recipes…" rows="1" maxlength="400"></textarea>
        <button id="cb-chat-send">Send</button>
      </div>
      <div id="cb-chat-byline">Powered by AI · The Caviar Bar</div>
    `;
    return panel;
  }

  function buildBubble() {
    const el = document.createElement('button');
    el.id = 'cb-chat-bubble';
    el.setAttribute('aria-label', 'Open concierge chat');
    el.innerHTML = `
      <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M20 2H4C2.9 2 2 2.9 2 4V22L6 18H20C21.1 18 22 17.1 22 16V4C22 2.9 21.1 2 20 2Z"
          fill="${GOLD}" opacity="0.9"/>
        <circle cx="8"  cy="10" r="1.5" fill="${NAVY}"/>
        <circle cx="12" cy="10" r="1.5" fill="${NAVY}"/>
        <circle cx="16" cy="10" r="1.5" fill="${NAVY}"/>
      </svg>
    `;
    return el;
  }

  function addMessage(container, role, text) {
    const el = document.createElement('div');
    el.className = `cb-msg cb-msg-${role}`;
    el.textContent = text;
    container.appendChild(el);
    container.scrollTop = container.scrollHeight;
    return el;
  }

  function showTyping(container) {
    const el = document.createElement('div');
    el.className = 'cb-msg cb-msg-typing';
    el.id = 'cb-typing';
    el.innerHTML = '<div class="cb-dots"><span></span><span></span><span></span></div>';
    container.appendChild(el);
    container.scrollTop = container.scrollHeight;
    return el;
  }

  function autoResize(textarea) {
    textarea.style.height = 'auto';
    textarea.style.height = Math.min(textarea.scrollHeight, 100) + 'px';
  }

  function init() {
    injectStyles();

    const bubble = buildBubble();
    const panel  = buildPanel();
    document.body.appendChild(bubble);
    document.body.appendChild(panel);

    const messages  = panel.querySelector('#cb-chat-messages');
    const input     = panel.querySelector('#cb-chat-input');
    const sendBtn   = panel.querySelector('#cb-chat-send');
    const closeBtn  = panel.querySelector('#cb-chat-close');

    let history = [];
    let opened  = false;

    // Greeting
    const GREETING = 'Good day. I\'m delighted to assist you. Whether you\'re choosing a caviar for the first time, planning a dinner, or looking for a gift, I\'m here to help. What can I do for you?';

    function open() {
      panel.classList.add('cb-open');
      bubble.setAttribute('aria-expanded', 'true');
      if (!opened) {
        addMessage(messages, 'assistant', GREETING);
        opened = true;
      }
      setTimeout(() => input.focus(), 50);
    }

    function close() {
      panel.classList.remove('cb-open');
      bubble.setAttribute('aria-expanded', 'false');
    }

    bubble.addEventListener('click', () => panel.classList.contains('cb-open') ? close() : open());
    closeBtn.addEventListener('click', close);

    input.addEventListener('keydown', (e) => {
      if (e.key === 'Enter' && !e.shiftKey) { e.preventDefault(); send(); }
    });
    input.addEventListener('input', () => autoResize(input));
    sendBtn.addEventListener('click', send);

    async function send() {
      const text = input.value.trim();
      if (!text) return;

      input.value = '';
      autoResize(input);
      sendBtn.disabled = true;

      addMessage(messages, 'user', text);
      history.push({ role: 'user', content: text });

      const typing = showTyping(messages);

      try {
        const res = await fetch(API, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({
            messages: history,
            sessionId: getSessionId(),
            pageUrl: window.location.href,
            referrer: document.referrer || '',
          }),
        });

        typing.remove();

        if (!res.ok) throw new Error('Service error');

        const data = await res.json();
        if (data.sessionId) {
          try { window.localStorage.setItem(SESSION_KEY, data.sessionId); } catch {}
        }
        const reply = data.reply || 'I apologise — something went wrong. Please try again or contact us at info@caviarbaruk.com.';

        addMessage(messages, 'assistant', reply);
        history.push({ role: 'assistant', content: reply });

      } catch {
        typing.remove();
        addMessage(messages, 'assistant', 'I\'m sorry, I\'m unable to respond at the moment. Please contact us at info@caviarbaruk.com or call 020 3005 1020.');
      } finally {
        sendBtn.disabled = false;
        input.focus();
      }
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
